import axios from 'axios'

const BRASIL_API_URL = 'https://brasilapi.com.br/api'

const limparDocumento = (doc) => String(doc || '').replace(/\D/g, '')

const validarCpfLocal = (cpf) => {
  const numeros = limparDocumento(cpf)
  if (numeros.length !== 11) return false
  if (/^(\d)\1{10}$/.test(numeros)) return false

  let soma = 0
  for (let i = 0; i < 9; i++) soma += parseInt(numeros[i]) * (10 - i)
  let resto = (soma * 10) % 11
  if (resto === 10 || resto === 11) resto = 0
  if (resto !== parseInt(numeros[9])) return false

  soma = 0
  for (let i = 0; i < 10; i++) soma += parseInt(numeros[i]) * (11 - i)
  resto = (soma * 10) % 11
  if (resto === 10 || resto === 11) resto = 0
  return resto === parseInt(numeros[10])
}

const validarCnpjLocal = (cnpj) => {
  const numeros = limparDocumento(cnpj)
  if (numeros.length !== 14) return false
  if (/^(\d)\1{13}$/.test(numeros)) return false

  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  let soma = 0
  for (let i = 0; i < 12; i++) soma += parseInt(numeros[i]) * pesos1[i]
  let resto = soma % 11
  const dig1 = resto < 2 ? 0 : 11 - resto
  if (parseInt(numeros[12]) !== dig1) return false

  soma = 0
  for (let i = 0; i < 13; i++) soma += parseInt(numeros[i]) * pesos2[i]
  resto = soma % 11
  const dig2 = resto < 2 ? 0 : 11 - resto
  return parseInt(numeros[13]) === dig2
}

/**
 * Valida CPF localmente e consulta nome na BrasilAPI (mesmo fluxo do cadastro de parceiro).
 * Retorna { valido, mensagem, dados? }
 */
export const validarCpf = async (cpf) => {
  const numeros = limparDocumento(cpf)
  if (!numeros) return { valido: false, mensagem: 'CPF é obrigatório' }
  if (numeros.length !== 11) return { valido: false, mensagem: 'CPF deve conter 11 dígitos' }
  if (!validarCpfLocal(cpf)) return { valido: false, mensagem: 'CPF inválido' }

  // Consulta na BrasilAPI é opcional (enriquecimento de nome). CPF com dígitos
  // verificadores corretos permanece válido mesmo se a API não retornar dados.
  try {
    const { data } = await axios.get(`${BRASIL_API_URL}/cpf/v1/${numeros}`, { timeout: 8000 })
    const nome = String(data?.nome ?? '').trim()

    return {
      valido: true,
      mensagem: 'CPF válido',
      dados: nome ? { nome } : undefined,
    }
  } catch {
    return { valido: true, mensagem: 'CPF válido' }
  }
}

/**
 * Valida CNPJ: primeiro localmente, depois consulta BrasilAPI para dados da empresa.
 * Retorna { valido, mensagem, dados? }
 */
export const validarCnpj = async (cnpj) => {
  const numeros = limparDocumento(cnpj)
  console.log('[validarCnpj] entrada:', { cnpj, numeros, length: numeros.length })
  if (!numeros) return { valido: false, mensagem: 'CNPJ é obrigatório' }
  if (numeros.length !== 14) return { valido: false, mensagem: 'CNPJ deve conter 14 dígitos' }

  const localValido = validarCnpjLocal(cnpj)
  console.log('[validarCnpj] validação local:', localValido)
  if (!localValido) return { valido: false, mensagem: 'CNPJ inválido' }

  try {
    console.log('[validarCnpj] chamando BrasilAPI:', `${BRASIL_API_URL}/cnpj/v1/${numeros}`)
    const { data } = await axios.get(`${BRASIL_API_URL}/cnpj/v1/${numeros}`)
    console.log('[validarCnpj] resposta BrasilAPI:', data)
    return {
      valido: true,
      mensagem: 'CNPJ válido',
      dados: {
        razaoSocial: data.razao_social || '',
        nomeFantasia: data.nome_fantasia || '',
        situacao: data.descricao_situacao_cadastral || '',
        uf: data.uf || '',
        municipio: data.municipio || '',
        bairro: data.bairro || '',
        logradouro: data.logradouro || '',
        numero: data.numero || '',
        complemento: data.complemento || '',
        cep: data.cep || '',
        atividadePrincipal: data.cnae_fiscal_descricao || ''
      }
    }
  } catch (error) {
    console.error('[validarCnpj] erro na chamada BrasilAPI:', error?.response?.status, error?.message)
    const status = error?.response?.status
    if (status === 404) return { valido: false, mensagem: 'CNPJ não encontrado na Receita Federal' }
    if (status === 400) return { valido: false, mensagem: 'CNPJ inválido' }
    return { valido: true, mensagem: 'CNPJ válido (validação online indisponível)' }
  }
}

/**
 * Valida documento genérico (CPF ou CNPJ) baseado no tipo.
 */
export const validarDocumento = async (documento, tipo = 'CPF') => {
  if (String(tipo).toUpperCase() === 'CNPJ') return validarCnpj(documento)
  return validarCpf(documento)
}

export { limparDocumento, validarCpfLocal, validarCnpjLocal }
